import { PaymentTerm } from '@domgen/dgx-fe-common';

export interface CmsProtectionBenefit {
  benefit: string;
  paymentTerm: PaymentTerm[];
}
